<template>
    <div class="models page" @click="setAnalytics">
        <div class="wrapper">
            <h1 v-if="mode === 'talents'">Talents</h1>
            <h1 v-if="mode === 'favorites'"><a href="/">Talents</a> > My Favorites ({{noofFavorites}})</h1>
            <favorites-tools v-if="mode === 'favorites'"></favorites-tools>
            <proposal-menu v-if="mode === 'proposal' && application" :application-id="applicationId" :proposal-id="proposalId"></proposal-menu>
            <filters v-if="mode === 'talents'"></filters>
        </div>
        <div class="models-container">
            <div class="models-result wrapper">
                <div v-for="(model, index) in currentList" :key="model.id" :class="'model skip'+index" :id="'model'+(counter+index)">
                    <div class="model-image">
                        <router-link v-if="windowWidth < 768" :to="'/'+folder+'/'+model.ID_Model" class="show-preview">
                            <picture>
                                <source :srcset="firstFoto(model)+'.webp'" type="image/webp">
                                <source :srcset="firstFoto(model)+'.jpg'" type="image/jpeg">
                                <img src="/images/assets/nix.gif" :data-src="firstFoto(model)+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter" class="lazy">
                            </picture>
                        </router-link>
                        <a v-if="windowWidth > 767" href="/model" class="show-preview" @click.prevent="previewModel(index+1)">
                            <picture>
                                <source :srcset="firstFoto(model)+'.webp'" type="image/webp">
                                <source :srcset="firstFoto(model)+'.jpg'" type="image/jpeg">
                                <img src="/images/assets/nix.gif" :data-src="firstFoto(model)+'.jpg'" :alt="model.Voornaam +' '+model.Achternaam_letter" class="lazy">
                            </picture>
                        </a>
                    </div>
                    <div v-if="!isFavorite(model.ID_Model)" class="footer" @click.stop="addToFavorites(model.ID_Model)">{{ model.Voornaam }} {{ model.Achternaam_letter }}</div>
                    <div v-if="isFavorite(model.ID_Model)" class="footer active" @click.stop="removeFromFavorites(model.ID_Model, (mode === 'talents' || mode === 'proposal'))">{{ model.Voornaam }} {{ model.Achternaam_letter }}</div>
                </div>
            </div>
            <div class="loader" v-if="showLoader && (mode === 'talents' || mode ==='proposal')">
                <img src="/assets/images/talents/loader.gif">
                <span id="loader-explain"> Even geduld alsjeblieft... </span>
            </div>
            <div v-if="showNoResult && mode === 'talents'" class='no-results'>{{ trans('talents.home.no_models_found') }}</div>
            <preview v-if="currentList" :index="index"></preview>
        </div>
        <div id="models-detail-overlay" ref="detailContainer">
            <!--<transition name="overlay">-->
            <router-view></router-view>
            <!--</transition>-->
        </div>
        <favorites v-if="mode === 'talents' && windowWidth > 500 && noofFavorites > 0"></favorites>
        <help-me v-if="showHelp"></help-me>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import {TweenMax} from "gsap/all"
    import Preview from './Preview.vue'
    import Detail from "./Detail.vue"
    import Filters from "./Filters.vue"
    import Favorites from "./Favorites.vue"
    import FavoritesTools from "./FavoritesTools"
    import ProposalMenu from "./ProposalMenu"
    import HelpMe from "./HelpMe"
    import cookies from "vue-cookies";

    export default {
        components: {
            FavoritesTools,
            Filters,
            Preview,
            Detail,
            Favorites,
            ProposalMenu,
            HelpMe
        },
        props: {
            mode: {default: 'default'},
            modelId: {default: null},
            applicationId: {default: null},
            proposalId: {default: null},
        },
        data: function () {
            return {
                scrollWait: false,
                showLoader: true,
                showModelDetail: false,
                showNoResult: false,
                helpShown: false,
                skip: 0,
                take: 20,
                index: 0,
                counter: 0,
                timer: false,
                idleTimer: 0,
                loadTimer: false,
                timesSearched: 0,
                timesClicked: 0,
            }
        },
        created() {
            this.$store.dispatch('setMode', this.mode)
            if (this.mode === 'proposal') {
                this.fetchProposal(this.applicationId,  this.proposalId)
                this.$store.dispatch('setProject', this.proposalId)
            }
            else {
                this.$store.dispatch('setProject', 'default')
            }
            this.setFavoritesIds()
            this.fetchModels()
            this.bindEvents()
        },
        mounted() {
            this.$on('reloadModels', () => this.resetModels())
            this.$on('hideHelpMe', () => this.hideHelp())
            window.addEventListener('resize', ev => {
                this.$store.dispatch('forceHidePreview')
            })
            this.timer = setInterval(function () {
                this.toggleLoaderExplain()
            }.bind(this), 1600)
            setInterval(function () {
                this.idleTimer++
            }.bind(this), 1000)
        },
        computed: {
            ...mapState(['models']),
            ...mapState(['favorites']),
            ...mapState(['application']),
            ...mapState(['forceHidePreview']),
            helpShownCookie(){
                return  cookies.isKey('helpShown') ? cookies.get('helpShown') : false
            },
            filters() {
                return this.$store.getters.filters()
            },
            searchEnded() {
                return this.$store.getters.searchEnded()
            },
            folder() {
                return this.mode === 'favorites' ? 'favorite' : 'model'
            },
            searchData() {
                return {skip: this.skip, take: this.take, filters: this.filters, firstModel: this.modelId}
            },
            searchProposedData() {
                return {skip: 0, model_ids: this.proposedModelIds}
            },
            overlay() {
                return this.$store.getters.overlay()
            },
            noofFavorites() {
                return this.favorites[this.project] ? this.favorites[this.project].length : ''
            },
            currentList() {
                return this.mode === 'favorites' ? this.favorites[this.project] : this.models
            },
            proposal(){
                return this.application ? this.application.roles[this.proposalId] : null
            },
            proposedModels() {
                return this.proposal ? this.proposal.models : null
            },
            proposedModelIds() {
                return this.proposedModels ? _.map(this.proposedModels, 'ID_Model') : null
            },
            showHelp(){
              return (this.idleTimer > 120 || this.timesSearched === 3 || this.noofFavorites === 3) && this.timesClicked > 6 && !this.helpShown && !this.helpShownCookie && this.mode === 'talents'
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.path === "/") {
                    this.hideModel()
                }
                else if (from.path === "/" || from.path === "/favorites" || from.path.indexOf('aanvraag') > 0) {
                    this.showModel()
                }
                else if (to.path.indexOf('aanvraag') > 0) {
                    this.hideModel()
                }
            },
            favoritesIds() {
                if (this.mode === 'talents' || this.mode === 'favorites') {
                    this.fetchFavorites()
                }
            },
            forceHidePreview(){
                // alert('123')
                //this.index = 0;
            },
            searchProposedData() {
                this.loadModels(this.searchProposedData)
            },
        },
        methods: {
            resetModels() {
                this.skip = 0
                this.showLoader = true
                this.$store.dispatch('resetModels')
                this.fetchModels()
            },
            bindEvents() {
                window.onscroll = function () {
                    this.loadMore()
                    this.fixEd()
                }.bind(this)
            },
            // fetchApplication() {
            //     this.$store.dispatch('loadApplication', this.applicationId)
            // },
            fetchModels() {
                clearTimeout(this.loadTimer);
                if (this.mode !== 'proposal') {
                    this.timesSearched++
                    this.loadModels(this.searchData)
                }
            },
            loadModels(data) {
                this.$store.dispatch('loadModels', data).then(() => {
                    this.loadTimer = setTimeout(function () {
                        this.showNoResult = false
                        if (this.models.length === 0) {
                            this.showNoResult = true
                        }
                        this.showLoader = false
                        this.scrollWait = false
                        if (typeof lazyLoadInstance !== "undefined") {
                            lazyLoadInstance.update()
                        }
                    }.bind(this), 4000)
                })
            },
            fetchFavorites() {
                let storage = localStorage.getItem('favorites_' + this.project);
                let ids = storage ? storage : []
                this.$store.dispatch('loadFavorites', ids)
                if (this.mode === 'favorites') {
                    setTimeout(function () {
                        this.showLoader = false
                    }.bind(this), 1000)
                }
                setTimeout(function () {
                    this.$store.dispatch('forceReloadFavorites')
                }.bind(this), 1200)

            },
            doSearch() {
                this.skip = this.skip + this.take
                this.fetchModels()
            },
            previewModel(index) {
                this.index = index
            },

            loadMore() {
                if (this.mode === 'talents') {
                    let scroll_top = window.scrollY
                    let near_bottom_margin = 200
                    let near_bottom_check = (scroll_top + this.windowHeight > this.documentHeight - near_bottom_margin)
                    if (near_bottom_check && !this.scrollWait) {
                        this.scrollWait = true
                        if (!this.searchEnded) {
                            this.showLoader = true
                            this.doSearch()
                        }
                    }
                }
            },
            showModel() {
                setTimeout(function () {
                    document.body.classList.add('noscroll')
                    TweenMax.to(this.$refs.detailContainer, 0.6, {top: 0})
                }.bind(this), 500)
            },

            hideModel() {
                document.body.classList.remove('noscroll')
                TweenMax.to(this.$refs.detailContainer, 0.3, {top: '100vh'})
            },
            fixEd() {
                if (window.scrollY > 90) {
                    document.body.classList.add('fixed')
                }
                else {
                    document.body.classList.remove('fixed')
                }
                if (window.scrollY > 200) {
                    document.body.classList.add('fixed2')
                }
                else {
                    document.body.classList.remove('fixed2')
                }
            },
            toggleLoaderExplain() {
                if (!this.searchEnded) {
                    let el = document.getElementById('loader-explain')
                    if (el) {
                        if (el.classList.contains('active')) {
                            el.classList.remove('active')
                        }
                        else {
                            el.classList.add('active')
                        }
                    }
                }
                else {
                    clearInterval(this.timer)
                }
            },
            hideHelp(){
                this.helpShown = true
                this.$cookies.set('helpShown', true)
            },
            setAnalytics(){
                this.timesClicked++
                this.idleTimer = 0;
            }
        },
    }
</script>
